import { Box, Tooltip } from '@mui/material';
import { alpha } from '@mui/material/styles';
import React, { useEffect } from 'react';
import { IconComponent } from '@zippeditoolsjs/zippedi-icons';

const materialIconStyle = { fontSize: 'inherit', lineHeight: 1 };

const getBoxSx = (variant, hexColor, color, fontSize, boxSize, sx) => ({
  mx: 1,
  p: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: boxSize,
  border: variant === 'outlined' ? '1px solid #e9e9f1' : 'none',
  borderRadius: '5px',
  backgroundColor: theme => {
    if (variant !== 'filled') return 'transparent';
    const raw = hexColor ? (hexColor.startsWith('#') ? hexColor : `#${hexColor}`) : null;
    const base = raw || theme.palette[color]?.main || theme.palette.info.main;
    return alpha(base, 0.2);
  },
  color: theme => {
    const raw = hexColor ? (hexColor.startsWith('#') ? hexColor : `#${hexColor}`) : null;
    return raw || theme.palette[color]?.main || theme.palette.info.main;
  },
  fontSize,
  ...sx,
});

// Based on PM's Icon.js — extended with hexColor and materialIcon for API data
export default function Icon(props) {
  const {
    color = 'info',
    hexColor,
    variant = 'filled',
    tooltip = '',
    iconName,       // Ionicons name (for @zippeditoolsjs/zippedi-icons)
    materialIcon,   // Google Material Icons name (uses MUI Icon font)
    sx,
    fontSize = '24px',
  } = props;

  const [boxSize, setBoxSize] = React.useState('auto');

  useEffect(() => {
    if (fontSize) {
      const INCREMENT_BOX_FACTOR = 7 / 4;
      const sizeList = fontSize.split('px');
      setBoxSize(
        sizeList.length > 1
          ? `${INCREMENT_BOX_FACTOR * parseInt(sizeList[0])}px`
          : 'auto',
      );
    }
  }, [fontSize]);

  return (
    <Tooltip title={tooltip}>
      <Box sx={getBoxSx(variant, hexColor, color, fontSize, boxSize, sx)}>
        {materialIcon
          ? <span className="material-icons" style={materialIconStyle}>{materialIcon}</span>
          : <IconComponent iconName={iconName} />
        }
      </Box>
    </Tooltip>
  );
}
